<button class="link" (click)="setActive(group)" [ngClass]="{'active':isActive(group)}"
        *ngFor="let group of groups">
    <div class="link-media" *ngIf="group.isInvalid">
        <fui-icon class="link-media-object" [height]="12" [icon]="'error'" [width]="12"></fui-icon>
    </div>
    <div class="link-label">
        <div class="link-label-title">
            {{group.title | translate}}
        </div>
    </div>
</button>
